import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import { useEnquiryModal } from "../context/EnquiryModalContext";
import { useTheme } from "../../contexts/ThemeContext";
import "./MaxHeader.css";

const LOGO_LIGHT_TEXT = `${process.env.PUBLIC_URL}/images/logos/Max_Logo_Dark_01.png`;
const LOGO_DARK_TEXT = `${process.env.PUBLIC_URL}/images/logos/Max_Logo_01.png`;

const NAV_LINKS = [
  { id: "home", label: "Home", href: "/", type: "link" },
  { id: "approach", label: "Approach", href: "#approach", type: "a" },
  { id: "segments", label: "Who we serve", href: "#segments", type: "a" },
  { id: "platform", label: "Platform", href: "/login", type: "link" },
  { id: "contact", label: "Contact", href: "#contact", type: "a" },
];

const MaxHeader = () => {
  const [open, setOpen] = useState(false);
  const [hoveredLink, setHoveredLink] = useState(null);
  const { openEnquiryModal } = useEnquiryModal();
  const { theme } = useTheme();

  const close = () => setOpen(false);

  const openEnquiry = (e) => {
    e.preventDefault();
    openEnquiryModal();
    close();
  };

  const currentLogo = theme === "dark" ? LOGO_LIGHT_TEXT : LOGO_DARK_TEXT;

  return (
    <header className="max-header">
      <div className="max-container max-header__inner">
        <button
          type="button"
          className="max-header__menu-btn"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} strokeWidth={1.75} /> : <Menu size={22} strokeWidth={1.75} />}
        </button>

        <Link to="/" className="max-header__brand" onClick={close}>
          <img
            src={currentLogo}
            alt="MaX Consulting"
            className="max-header__logo"
            width={323}
            height={66}
          />
        </Link>

        <nav 
          className={`max-header__nav ${open ? "max-header__nav--open" : ""}`}
          onMouseLeave={() => setHoveredLink(null)}
        >
          {NAV_LINKS.map((link) => {
            const isLink = link.type === "link";
            const action = link.id === "contact" ? openEnquiry : close;

            const content = (
              <>
                <span style={{ position: "relative", zIndex: 1 }}>{link.label}</span>
                {hoveredLink === link.id && (
                  <motion.div
                    layoutId="nav-bubble"
                    className="max-header__link-bubble"
                    transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
                  />
                )}
              </>
            );

            return isLink ? (
              <Link
                key={link.id}
                to={link.href}
                className="max-header__link"
                onClick={action}
                onMouseEnter={() => setHoveredLink(link.id)}
              >
                {content}
              </Link>
            ) : (
              <a
                key={link.id}
                href={link.href}
                className="max-header__link"
                onClick={action}
                onMouseEnter={() => setHoveredLink(link.id)}
              >
                {content}
              </a>
            );
          })}
        </nav>

        <div className="max-header__actions">
          <a href="#contact" className="max-btn max-btn--primary max-header__cta" onClick={openEnquiry}>
            <span className="max-header__cta-text--desktop">Schedule a conversation</span>
            <span className="max-header__cta-text--mobile">Schedule</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default MaxHeader;
